import { useState } from "react";
import PropTypes from "prop-types";
import GrIcon from "src/design-system/components/GrIcon";
import GrIconButton from "src/design-system/components/GrIconButton";
import { GrMenu, GrMenuItem } from "src/design-system/components/GrMenu";
import icons from "src/design-system/icons";
import { gr } from "src/design-system/tokens";

// ⋮ menu on the member's own feed post or comment: "Edit" and "Delete" (red, two-tone trash).
// Light fill so the ⋮ reads as a button (same as the friend card ⋯); open look while the menu is open.
const triggerSx = {
  background: gr.color.bg,
  color: gr.color.ink2,
  "&:hover": { background: gr.color.tint, color: gr.color.brandDark },
};

export default function FeedMoreMenu({ onEdit, onDelete, size = "sm", sx }) {
  const [anchor, setAnchor] = useState(null);
  const close = () => setAnchor(null);
  const run = (action) => () => {
    close();
    action();
  };

  return (
    <>
      <GrIconButton
        variant="ghost"
        size={size}
        aria-label="More options"
        aria-haspopup="menu"
        aria-expanded={Boolean(anchor)}
        onClick={(event) => setAnchor(event.currentTarget)}
        sx={{ ...triggerSx, ...sx }}
      >
        <GrIcon icon={icons.more} />
      </GrIconButton>
      <GrMenu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={close}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <GrMenuItem onClick={run(onEdit)}>
          <GrIcon icon={icons.edit} size="md" />
          Edit
        </GrMenuItem>
        <GrMenuItem danger onClick={run(onDelete)}>
          <GrIcon icon={icons.deleteTwoTone} size="md" />
          Delete
        </GrMenuItem>
      </GrMenu>
    </>
  );
}

FeedMoreMenu.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  size: PropTypes.oneOf(["sm", "md"]),
  sx: PropTypes.object,
};
